import { Image, ImageSource } from 'expo-image';
import { TabTriggerSlotProps } from 'expo-router/ui';
import { Platform, Pressable, StyleSheet, useColorScheme } from 'react-native';

import { Colors } from '@/constants/Colors';

import Text from './Text';

export type TabButtonProps = TabTriggerSlotProps & {
  iconSource?: string | number | string[] | ImageSource | ImageSource[];
  label: string;
};

const TabButton = ({ iconSource, label, isFocused, ...props }: TabButtonProps) => {
  const colorScheme = useColorScheme() === 'dark' ? 'dark' : 'light';

  const focusedTintColor = Colors[colorScheme].tabIconSelected;
  const defaultTintColor = Colors[colorScheme].tabIconDefault;

  return (
    <Pressable {...props} onPress={props.onPress} style={styles.pressable}>
      <Image
        style={{ ...styles.navBarIcon, tintColor: isFocused ? focusedTintColor : defaultTintColor }}
        source={iconSource}
      />
      <Text
        fontWeight="450"
        style={[
          { fontSize: 12 },
          isFocused ? { color: focusedTintColor } : { color: defaultTintColor },
          Platform.OS === 'android' && { width: 42, textAlign: 'center' }
        ]}>
        {label}
      </Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  pressable: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 4,
    paddingHorizontal: 16,
    paddingTop: 18
  },

  navBarIcon: {
    width: 24,
    height: 24
  }
});

export default TabButton;
